import { render, staticRenderFns } from "./DeveloperModeIndicator.vue?vue&type=template&id=13fff0e1&"
import script from "./DeveloperModeIndicator.vue?vue&type=script&lang=js&"
export * from "./DeveloperModeIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperModeIndicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports